// src/context/ToastProvider.jsx
import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ToastContext } from "./ToastContext";

const ToastItem = ({ toast, onRemove }) => {
  useEffect(() => {
    const id = setTimeout(() => onRemove(toast.id), toast.duration);
    return () => clearTimeout(id);
  }, [toast.id, toast.duration, onRemove]);

  const typeClass = ["success", "error", "warning", "info"].includes(toast.type)
    ? toast.type
    : "info";

  return (
    <div className={`toast toast--${typeClass}`} role="status">
      <span className="toast-message">{toast.message}</span>
      <button
        type="button"
        className="toast-close"
        onClick={() => onRemove(toast.id)}
        aria-label="Закрыть"
      >
        ×
      </button>
    </div>
  );
};

const ToastContainer = ({ toasts, removeToast }) => {
  if (!toasts.length) return null;
  return createPortal(
    <div className="toast-container">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onRemove={removeToast} />
      ))}
    </div>,
    document.body,
  );
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = "info", duration = 14000) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type, duration }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
};
